module.exports = __webpack_public_path__ + "13b2468c35b7056bb909b4ef48b37096.png";


//////////////////
// WEBPACK FOOTER
// ./client/assets/img/clientes.png
// module id = 128
// module chunks = 0